import { Component } from '@angular/core';

@Component({
  selector: 'app-redirect-tbk',
  template: '<div>redirect</div>',
  styles: [
    `
    div {
      display: none;
    }
    `
  ]
})
export class RedirectTbkComponent {

}
